import React from 'react';
import { resolveIcon } from '../components/common/IconResolver';

export interface ViewContext {
  viewKey: string;
  navItemId: string;
  groupId?: string;
  groupLabel?: string;
  itemLabel?: string;
  stubMetadata?: {
    title?: string;
    description?: string;
    icon?: string;
    expectedPhase?: string;
  };
}

interface StubPageProps {
  context?: ViewContext;
}

const StubPage: React.FC<StubPageProps> = ({ context }) => {
  const title = context?.stubMetadata?.title || context?.itemLabel || 'Coming Soon';
  const description = context?.stubMetadata?.description ||
    'This module is under development and will be available in a future release.';
  const icon = context?.stubMetadata?.icon || 'layers';
  const expectedPhase = context?.stubMetadata?.expectedPhase;
  const parentLabel = context?.groupLabel;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '48px 24px',
      textAlign: 'center',
    }}>
      {/* Breadcrumb */}
      {parentLabel && (
        <div style={{
          fontSize: '13px',
          color: 'var(--text-secondary, #94a3b8)',
          marginBottom: '24px',
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
        }}>
          {parentLabel} &rarr; {context?.itemLabel || title}
        </div>
      )}

      {/* Icon */}
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '20px',
        background: 'rgba(124, 58, 237, 0.1)',
        border: '1px solid rgba(124, 58, 237, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '24px',
      }}>
        <div style={{ color: 'var(--primary, #7c3aed)' }}>
          {resolveIcon(icon, 36)}
        </div>
      </div>

      {/* Title */}
      <h2 style={{
        fontSize: '24px',
        fontWeight: 600,
        color: 'var(--text-primary, #e2e8f0)',
        margin: '0 0 12px 0',
      }}>
        {title}
      </h2>

      {/* Description */}
      <p style={{
        fontSize: '15px',
        color: 'var(--text-secondary, #94a3b8)',
        maxWidth: '480px',
        lineHeight: 1.6,
        margin: '0 0 24px 0',
      }}>
        {description}
      </p>

      {/* Expected phase badge */}
      {expectedPhase && (
        <div style={{
          padding: '6px 16px',
          borderRadius: '20px',
          background: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          fontSize: '12px',
          color: 'var(--text-secondary, #94a3b8)',
        }}>
          Expected: Phase {expectedPhase}
        </div>
      )}
    </div>
  );
};

export default StubPage;
